import React from 'react';

const dotStyle: React.CSSProperties = {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'var(--gray-dark, #9b9b9b)',
    display: 'inline-block',
    animationName: 'chatbot-bounce',
    animationDuration: '1.4s',
    animationIterationCount: 'infinite',
    animationFillMode: 'both',
};

const keyframes = `
@keyframes chatbot-bounce {
    0%, 80%, 100% {
        transform: scale(0);
        opacity: 0.4;
    }
    40% {
        transform: scale(1);
        opacity: 1;
    }
}
`;

const LoadingIndicator: React.FC = () => {
    return (
        <div className="display-flex margin-bottom-10 justify-content-start" data-testid="loading-indicator">
            <style>{keyframes}</style>
            <div className="bg-lighter rounded padding-10 padding-left-15 padding-right-15">
                <div className="display-flex align-items-center gap-5">
                    <span style={{ ...dotStyle, animationDelay: '0s' }} data-testid="loading-dot" />
                    <span style={{ ...dotStyle, animationDelay: '0.16s' }} data-testid="loading-dot" />
                    <span style={{ ...dotStyle, animationDelay: '0.32s' }} data-testid="loading-dot" />
                </div>
            </div>
        </div>
    );
};

export default LoadingIndicator;
